// Подтверждение действия фирменным диалогом вместо системного window.confirm.
//   if (!(await nfConfirm('Удалить товар?', { confirmText: 'Удалить' }))) return;
// Диалог рисует <ConfirmHost /> (подключён в App). Если хост не смонтирован
// (например, в тестах) — откатываемся на window.confirm, чтобы вызов не завис.

let listener = null;

export function setConfirmListener(fn) {
  listener = fn;
  return () => { if (listener === fn) listener = null; };
}

export function nfConfirm(message, options = {}) {
  if (!listener) return Promise.resolve(window.confirm(message));
  return new Promise(resolve => listener({ message, ...options, resolve }));
}
